// extracted by mini-css-extract-plugin
module.exports = {"container":"Segment_container__2KO0e","outerCircle":"Segment_outerCircle__3Ew5J","innerCircle":"Segment_innerCircle__1OWa4"};